import React, { useState } from 'react';
import { Button, message } from 'antd';
import { ClockCircleFilled, CloseCircleFilled, DownOutlined, SyncOutlined, UpOutlined } from '@ant-design/icons';
import type { TEhrStepsConfig } from 'types/ehrConnection';
import EhrStepGuide from './EhrStepGuide';
import s from './s.module.less';

type Props = {
    // fail = 红色失败卡；pending = 琥珀色进行中（PF 交码后后台开通）
    tone: 'fail' | 'pending';
    title: string;
    desc?: React.ReactNode;
    agentEmail: string;
    stepsConfig?: TEhrStepsConfig;
    onBack: () => void;
    // 不传则不显示主按钮（如 PF 开通中，只能等）
    onRetry?: () => void;
    retryLabel?: string;
};

// 验证 / 保存结果卡（同 SimplePractice 等邀请型的验证失败页）：图标 + 标题 + 说明，
// agent 邮箱 + Copy，可展开的 setup steps，Go back / 重试
export default function VerifyResultCard({
    tone,
    title,
    desc,
    agentEmail,
    stepsConfig,
    onBack,
    onRetry,
    retryLabel = 'Retry verification',
}: Props) {
    const [showSteps, setShowSteps] = useState(false);
    const pending = tone === 'pending';

    return (
        <div className={pending ? s.verifyPending : s.verifyFail}>
            <div className={pending ? s.verifyPendingIcon : s.verifyFailIcon}>
                {pending ? <ClockCircleFilled /> : <CloseCircleFilled />}
            </div>
            <div className={s.verifyFailTitle}>{title}</div>
            {desc && <div className={s.verifyFailDesc}>{desc}</div>}
            <div className={s.verifyEmailHelper}>
                <div className={s.verifyEmailHelperLabel}>Make sure you invited this email:</div>
                <div className={s.verifyEmailRow}>
                    <div className={s.verifyEmailDisplay}>{agentEmail}</div>
                    <Button
                        icon={<SyncOutlined />}
                        onClick={() => {
                            navigator.clipboard.writeText(agentEmail);
                            message.success('Email copied');
                        }}
                    >
                        Copy
                    </Button>
                </div>
            </div>
            {stepsConfig && (
                <>
                    <span className={s.verifyShowSteps} onClick={() => setShowSteps(!showSteps)}>
                        {showSteps ? 'Hide' : 'Show'} setup steps
                        {showSteps ? <UpOutlined /> : <DownOutlined />}
                    </span>
                    {showSteps && (
                        <div style={{ marginTop: 16, textAlign: 'left' }}>
                            <EhrStepGuide config={stepsConfig} agentEmail={agentEmail} />
                        </div>
                    )}
                </>
            )}
            <div className={s.verifyActions} style={{ marginTop: 24 }}>
                <Button onClick={onBack}>Go back</Button>
                {onRetry && (
                    <Button type="primary" onClick={onRetry}>
                        {retryLabel}
                    </Button>
                )}
            </div>
        </div>
    );
}
